import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const Portfolio = lazy(() => import('../pages/portfolio/page'));
const Blog = lazy(() => import('../pages/blog/page'));
const Promo = lazy(() => import('../pages/promo/page'));
const Booking = lazy(() => import('../pages/booking/page'));
const Tracking = lazy(() => import('../pages/tracking/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/portofolio',
    element: <Portfolio />
  },
  {
    path: '/blog',
    element: <Blog />
  },
  {
    path: '/blog/:slug',
    element: <Blog />
  },
  {
    path: '/promo',
    element: <Promo />
  },
  {
    path: '/booking',
    element: <Booking />
  },
  {
    path: '/tracking',
    element: <Tracking />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
